'use client';

import React, { createContext, useState, useContext, useEffect } from 'react';
const NavVisibilityContext = createContext(null);
export const NavVisibilityProvider = ({
  children
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const threshold = 45;
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY < lastScrollY || currentScrollY < threshold) {
      setIsVisible(true);
    } else if (currentScrollY > threshold && currentScrollY > lastScrollY) {
      setIsVisible(false);
    }
    setLastScrollY(currentScrollY);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  return <NavVisibilityContext.Provider value={{
    isVisible
  }} data-sentry-element="unknown" data-sentry-component="NavVisibilityProvider" data-sentry-source-file="NavVisibilityContext.tsx">{children}</NavVisibilityContext.Provider>;
};
export const useNavVisibility = () => {
  const context = useContext(NavVisibilityContext);
  if (context === null) {
    throw new Error('use this within a navvisibility provider');
  }
  return context;
};